import { useEffect } from 'react'
import { useBatchImagePreloader } from '@/hooks/useImagePreloader'
import { LeaderboardEntry } from '@/types'

interface LeaderboardAvatarPreloaderProps {
  entries: LeaderboardEntry[]
  onProgress?: (progress: number) => void
}

export function LeaderboardAvatarPreloader({ 
  entries, 
  onProgress 
}: LeaderboardAvatarPreloaderProps) {
  // 提取所有头像URL
  const avatarUrls = entries
    .map(entry => entry.user.avatar)
    .filter(Boolean) as string[]

  const { progress } = useBatchImagePreloader(avatarUrls, {
    batchSize: 5, // 每批加载5个头像
    priority: false,
    timeout: 8000 // 8秒超时
  })

  useEffect(() => {
    onProgress?.(progress)
  }, [progress, onProgress])

  // 这个组件不渲染任何内容，只负责预加载
  return null
}

// 排行榜加载进度指示器
interface LeaderboardLoadingIndicatorProps {
  progress: number
  isVisible: boolean
}

export function LeaderboardLoadingIndicator({ 
  progress, 
  isVisible 
}: LeaderboardLoadingIndicatorProps) {
  if (!isVisible || progress >= 1) return null

  return (
    <div className="fixed top-4 right-4 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-lg p-3 shadow-lg z-50">
      <div className="flex items-center space-x-3">
        <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        <div className="text-sm text-gray-600">
          加载头像中... {Math.round(progress * 100)}%
        </div>
      </div>
      <div className="mt-2 w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-blue-500 transition-all duration-300 ease-out"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  )
}
